module.exports = __webpack_public_path__ + "static/media/shark_haven_logo.1aaa154c.png";